<template>
	<div class="container page">
		<van-nav-bar :title="$t('my.task_record')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="main">

			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
				<div v-else class="item_list" v-for="(v,key) in list" :key="key">
					<div class="lottery_info">
						<van-image class="cover" :src="v.ico">
							<template v-slot:loading>
								<van-loading type="spinner" />
							</template>
						</van-image>
						<span class="period-number">{{v.expect}}</span>
						<span class="period-number">{{v.name}}</span>
					</div>
					<div class="recent">
						<div class="kuaisan-ball left">
							<div>
								<span>{{$t("reservation.result")}}</span>
								<span class="ressquareBox">{{ v.size }}</span>
								<span class="ressquareBox">{{ v.double }}</span>

							</div>

						</div>
					</div>
					
					<div class="topInfo">

						<span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
						<span v-else>{{v.status_text}}</span>
						<span>{{$t("reservation.money")}}：{{v.money}}</span>
					</div>
					<!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
					<!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
					<div class="time">
						<span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
					</div>
					<div class="time">
						<span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				list: [],
				sum: '',
				double: '',
				size: ""

			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
				}, 500);
			},

			getUserGameList() {
				this.$http({
					method: 'get',
					url: 'user_get_game_list'
				}).then(res => {

					if (res.code !== 200) {
						this.$toast(res.msg || 'error');
						return;
					}

					const lang = localStorage.getItem('lang') || 'en';

					// 兜底：保证 list 永远是数组
					const list = Array.isArray(res.data) ? res.data : [];

					this.list = list.map(item => {

						// 兜底：解析 opencode
						let codes = [];

						if (Array.isArray(item.opencode)) {
							codes = item.opencode.map(n => Number(n) || 0);
						} else if (typeof item.opencode === 'string') {
							codes = item.opencode.split(',').map(n => Number(n) || 0);
						}

						// 补齐 3 位
						while (codes.length < 3) {
							codes.push(0);
						}

						const sum = codes[0] + codes[1] + codes[2];

						// size
						let size = '--';
						if (sum >= 11 && sum <= 18) {
							size = lang === 'zh' ? '玫瑰' :
								lang === 'en' ? 'Rose' :
								lang === 'ja' ? 'バラ' :
								'청순한';
						} else if (sum >= 3 && sum <= 10) {
							size = lang === 'zh' ? '百合' :
								lang === 'en' ? 'Lily' :
								lang === 'ja' ? 'リリー' :
								'섹시한';
						}

						// double
						let double = '--';
						if (sum % 2 === 0) {
							double = lang === 'zh' ? '氣球' :
								lang === 'en' ? 'Balloon' :
								lang === 'ja' ? '気球' :
								'패티쉬';
						} else {
							double = lang === 'zh' ? '煙花' :
								lang === 'en' ? 'Fireworks' :
								lang === 'ja' ? '花火' :
								'귀여운';
						}

						// 把结果写回每一项（关键）
						return {
							...item,
							sum,
							size,
							double
						};
					});

				}).catch(() => {
					this.list = [];
				});
			},
			// getUserGameList() {
			// 	this.$http({
			// 		method: 'get',
			// 		url: 'user_get_game_list'
			// 	}).then(res => {
			// 		if (res.code === 200) {
			// 			const lanng = localStorage.getItem("lang");
			// 			this.list = res.data;

			// 			// this.rose = '청순한';
			// 			// this.lily = '섹시한';
			// 			// this.balloon = '패티쉬'
			// 			// this.fireworks = '귀여운'

			// 			this.list.forEach(item => {
			// 				const sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
			// 				if (sum >= 11 && sum <= 18) {
			// 					lanng == 'zh' ? this.size = '玫瑰' : lanng == 'en' ? this.size = 'Rose' :
			// 						lanng == 'ja' ? this.size = 'バラは' : this.size = '청순한'
			// 				} else if (sum >= 3 && sum <= 10) {
			// 					lanng == 'zh' ? this.size = '百合' : lanng == 'en' ? this.size = 'Lily' :
			// 						lanng == 'ja' ? this.size = "リリー·リリー" : this.size = '섹시한'
			// 				}
			// 				if (sum % 2 === 0) {
			// 					lanng == 'zh' ? this.double = "氣球" : lanng == 'en' ? this.double =
			// 						"Balloon" : lanng == 'ja' ? this.double = "气球" : this.double = "패티쉬";
			// 				} else {
			// 					lanng == 'zh' ? this.double = "煙花" : lanng == 'en' ? this.double =
			// 						"fireworks" : lanng == 'ja' ? this.double = "花火大会" :
			// 						this.double = "귀여운";
			// 				}
			// 			})
			// 			console.log(this.size, this.double, 998);
			// 		} else if (res.code === 401) {
			// 			this.$toast(res.msg);
			// 		}
			// 	})
			// },

		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserGameList();
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		overflow: auto;
		background-color: #f2f2f5;
		height: 100%;
		padding: 0 10px;
	}

	.item_list {
		padding: 15px 15px;
		margin: 30px 10px;
		background: #fff;
		border-radius: 10px;
		line-height: 60px;
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 32px;
		font-weight: 700;
		color: #000;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #000;
	}

	.item_list .topInfo span:last-child {}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}

	.item_list .cover {
		width: 60px;
		height: 60px;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.item_list .period-number {
		margin-left: 50px;
		margin-right: 10px;
		height: 50px;
		line-height: 60px;
		font-size: 35px;
		font-weight: 700;
		color: #000;
	}

	.item_list .lottery_info {
		display: flex;
	}

	.recent {
		display: flex;
		align-items: center;
		height: 100px;
	}

	.kuaisan-ball .left {
		justify-content: flex-start;
	}

	.kuaisan-ball {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.kuaisan-ball .res-img {
		width: 70px;
		height: 70px;
		margin-right: 30px;
	}

	.kuaisan-ball .res-des {
		font-weight: 700;
		text-align: center;
		color: #000;
	}

	.kuaisan-ball .res-des.middle {
		width: 15%;
		font-size: 35px;
	}

	.ressquareBox {
		background: linear-gradient(90deg, #f560cd, #4f2b8a);
		color: #fff;
		height: 7vw;
		line-height: 7vw;
		text-align: center;
		font-size: 3vw;
		font-weight: 700;
		border-radius: 16px;
		margin-left: 20px;
		padding: 13px 40px;
		min-width: 13vw;
	}
</style>